/**
 * 人事管理api
 */
export default {
  // 员工资料api
  employeeDelete: '/employeeInfo/delete', //{employeeId}删除员工(post)
  employeeDownload: '/employeeInfo/download', //下载模板(post)
  importEmployee: '/employeeInfo/importEmployee', //导入(post)
  insert: '/employeeInfo/insert', //新增员工(post)
  employeeSelect: '/employeeInfo/select', //查询员工（分页）（get）
  employeeUpdate:'/employeeInfo/update',//修改员工信息(post)
  // 部门管理api
  departmentInfoDelete:'/departmentInfo/delete/',//{departmentId}删除部门(post)
  departmentInfoInsert:'/departmentInfo/insert',//新增部门(post)
  departmentInfoSelect:'/departmentInfo/select',//查询部门(get)
  departmentInfoUpdate:'/departmentInfo/update',//修改部门(post)
  selectParentDepartment:'/departmentInfo/selectParentDepartment',//查询上级部门下拉框(get)
  // 职位管理api
  positionInfoDelete:'/positionInfo/delete',///{positionId}删除职位(post)
  positionInfoInsert:'/positionInfo/insert',//新增职位(post)
  positionInfoSelect:'/positionInfo/select',//查询职位(get)
  positionInfoUpdate:'/positionInfo/update',//修改职位(post)
  
};

